import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Ingredient, IngredientsState } from 'src/app/shared/model';

import * as IngredientsActions from './ingredients.actions';

export const adapter: EntityAdapter<Ingredient> = createEntityAdapter<Ingredient>();
export const initialState: IngredientsState = adapter.getInitialState({});

export const ingredientsReducer = createReducer<IngredientsState>(
  initialState,
  on(IngredientsActions.loadIngredientsSuccess, (state, { ingredients }) =>
    adapter.setAll(ingredients, state),
  ),
);
